import React from "react";
import Card from "react-bootstrap/Card";

export default class IndexAdminCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { contractorId, defaultCompanyId } = this.props;

    return (
      <Card body>
        Admin
        <br />
        <ul>
          <li>
            <a href="/calls">Queues</a>
          </li>
          <li>
            <a href="/contractor_users">Contractors Monthly Stats</a>
          </li>
          <li>
            <a href="https://modeanalytics.com/voiceops/reports/85e6f7607f1e">
              Analyst Productivity Dashboard
            </a>
          </li>
          <li>
            <a href="https://modeanalytics.com/voiceops/reports/54ca5ee59551">
              Transcription QA Dashboard
            </a>
          </li>
          <li>
            <a href="/contractor_users/new">Create a Contractor</a>
          </li>
          <li>
            <a href="/contractor_users/manage_activity">Manage Transcribers</a>
          </li>
          <li>
            <a href="/companies/edit_glossary">Update Glossary</a>
          </li>
        </ul>
        <br />
        Payments
        <ul>
          <li>
            <a href="/contractor_users/payment">Summary</a>
          </li>
          <li>
            <a href="/companies/edit_scoring_rate">Rates</a>
          </li>
        </ul>
        <br />
        Scoring
        <ul>
          <li>
            <a href="/contractor_users/qa_dash">Certifications / Roster</a>
          </li>
          <li>
            <a href="/contractor_users/contractor_qualifications">
              Qualifications
            </a>
          </li>
          <li>
            <a href={"/contractor_users/" + contractorId + "/training"}>
              Training
            </a>
          </li>
          <li>
            <a href={"/qa_quiz/" + contractorId + "/creation"}>Quiz Creator</a>
          </li>
          <li>
            <a href="/calibrations">Quiz Results</a>
          </li>
          <li>
            <a href="/scorer_applicants">Scorer Applicants</a>
          </li>
        </ul>
        <br />
        QA
        <ul>
          <li>
            <a href={"/contractor_users/" + defaultCompanyId + "/qa_overview"}>
              Overview
            </a>
          </li>
          <li>
            <a href={"/contractor_users/" + defaultCompanyId + "/admin_qa"}>
              QA TODO
            </a>
          </li>
          <li>
            <a href="/qa_records/false_negatives">False Negatives</a>
          </li>
          <li>
            <a href="/contractor_users/final_qa">Final QA</a>
          </li>
          <li>
            <a href="/outcome_values_qa">Callback Scheduling QA</a>
          </li>
        </ul>
        <br />
        <a href="/contractor_users/logout">Logout</a>
      </Card>
    );
  }
}
